import React from "react"
import Section from "./section"
import DfbHeadline from "../ui-kit/dfb_headline"
import CCardFact from "../elements/c_card_fact"

const MCardGridFacts = ({ data }) => {
  const { headline, facts } = data

  return (
    <Section baseClass="m-CardGrid" defaultPadding="large" data={data}>
      <div className="m-CardGrid-wrapper">
        <div className="m-CardGrid-container">
          {headline && (
            <DfbHeadline
              headline={headline}
              headline_level="h2"
              add_class="m-CardGrid-headline"
            />
          )}
        </div>
        <div className="c-CardGrid c-CardGrid--facts">
          <div className="c-CardGrid-container">
            {facts &&
              facts.map((item, index) => {
                return (
                  <div className="c-CardGrid-card" key={index}>
                    <CCardFact
                      type={item.facts_layout}
                      headline={item.facts_headline}
                      subline={item.facts_sub_headline}
                      icon={item.facts_icon}
                      description={item.facts_text}
                      anchor={item.facts_link_text}
                      href={item.facts_link}
                      target={item.facts_link_target}
                    />
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardGridFacts
